import { Divider, Grid, GridItem, HStack, Heading, Text, VStack } from "@chakra-ui/react";
import { BreifCaseIcon, LibraryIcon, UniversityIcon } from "src/resources/icons";
import React from "react";
import { PROFILE_HEADINGS_HIN } from "src/common/constants/hindiLabels";
import { PROFILE_HEADINGS_ENG } from "src/common/constants/englishLabels";
import { useSelector } from "react-redux";
import { RootState } from "src/store/store";

interface ProfessionalProps {
  userData: any;
}

export const ProfessionalBackground: React.FC<ProfessionalProps> = ({ userData }) => {
  const businessDetails = userData?.businessDetails || {};
  const globalInfo = useSelector((state: RootState) => state.globalInfo);
  const { globalLanguage } = globalInfo;
  const isHindiLabels = globalLanguage === 'HI';

  return (
    <Grid templateColumns="repeat(2, 1fr)" gap="1rem">
      {/* Occupation */}
      <GridItem>
        <VStack alignItems="flex-start">
          <HStack>
            <UniversityIcon />
            <Heading fontSize="24px">{isHindiLabels ? PROFILE_HEADINGS_HIN.OCCUPATION : PROFILE_HEADINGS_ENG.OCCUPATION}</Heading>
          </HStack>
          <Text>{businessDetails.occupation || "N/A"} </Text>
        </VStack>
      </GridItem>

      {/* Educational Qualification */}
      <GridItem>
        <VStack alignItems="flex-start">
          <HStack>
            <LibraryIcon />
            <Heading fontSize="24px">{isHindiLabels ? PROFILE_HEADINGS_HIN.EDUCATIONAL_QUALIFICATION : PROFILE_HEADINGS_ENG.EDUCATIONAL_QUALIFICATION}</Heading>
          </HStack>
          <Text>{businessDetails.educationalQualification || "N/A"}</Text>
        </VStack>
      </GridItem>

      <GridItem colSpan={2}>
        <Divider my="1rem" />
      </GridItem>

      {/* Business Details */}
      <GridItem colSpan={2}>
        <VStack alignItems="flex-start">
          <HStack>
            <BreifCaseIcon />
            <Heading fontSize="24px">{isHindiLabels ? PROFILE_HEADINGS_HIN.BUSINESS_DETAILS : PROFILE_HEADINGS_ENG.BUSINESS_DETAILS}</Heading>
          </HStack>
          <Text>{businessDetails?.businessDetails || businessDetails?.business || "None"}</Text>
        </VStack>
      </GridItem>
    </Grid>
  );
};
